<template>
  <DSelect
    :items="itemsFiltered"
    :show="show"
    :itemsSelected="itemsSelected"
    :placeholder="placeholder"
    :isDeleteAllAnOption="false"
    @update="update"
    @multiPaste="onMultiPaste"
    @close="$emit('close')">
    <h4 slot="noMatch">En person må have max seks kompetencer</h4>
  </DSelect>
</template>
<script>
import DSelect from '../../DSelect/DSelectCals'
import eventbus from '../../../eventbus'
import { parseSubjectListPaste, constants } from './pasteTableMatcher'

export default {
  components: {DSelect},
  props: {
    items: {
      default: () => [],
      type: Array
    },
    itemsSelected: {
      default: () => [],
      type: Array
    },
    placeholder: {
      type: String,
      default: 'Søg og vælg kompetence'
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    itemsFiltered () {
      if (this.itemsSelected.length > 5) {
        return []
      }
      return this.items.filter(item => this.itemsSelected.findIndex(itemSelected => itemSelected.subject_code === item.subject_code) < 0)
    }
  },
  methods: {
    update (val) {
      this.$emit('update', val)
    },
    onMultiPaste (text) {
      const result = parseSubjectListPaste(text, 'L', this.items)
      const existingCodes = this.itemsSelected.map(item => item.subject_code)
      const additions = []
      const duplicates = []
      result.matched.forEach(({ raw, item }) => {
        if (existingCodes.indexOf(item.subject_code) > -1) {
          duplicates.push(raw)
          return
        }
        if (additions.findIndex(a => a.subject_code === item.subject_code) > -1) {
          duplicates.push(raw)
          return
        }
        additions.push(item)
      })
      const totalAfter = this.itemsSelected.length + additions.length
      let overflow = []
      let toAdd = additions
      if (totalAfter > constants.MAX_COMPETENCIES) {
        const room = Math.max(0, constants.MAX_COMPETENCIES - this.itemsSelected.length)
        toAdd = additions.slice(0, room)
        overflow = additions.slice(room)
      }

      if (toAdd.length > 0) {
        const next = this.itemsSelected.concat(toAdd)
        this.$emit('update', next)
      }

      this.reportPasteFeedback({
        added: toAdd,
        duplicates: duplicates,
        overflow: overflow,
        notFound: result.notFound,
        ambiguous: result.ambiguous
      })
    },
    reportPasteFeedback (info) {
      const issues = []
      if (info.notFound.length > 0) {
        issues.push('ukendte: ' + info.notFound.map(n => n.raw).join(', '))
      }
      if (info.ambiguous.length > 0) {
        issues.push('flere mulige matches: ' + info.ambiguous.map(a => a.raw).join(', '))
      }
      if (info.overflow.length > 0) {
        issues.push('over 6-grænsen: ' + info.overflow.map(o => o.name).join(', '))
      }
      if (info.duplicates.length > 0) {
        issues.push('allerede valgt: ' + info.duplicates.join(', '))
      }
      // Når alle paste-fag blev tilføjet uden problemer, lader vi parent
      // KompetenceIndberetningLinjeFag's egen success-toast tale; ellers
      // viser vi her hvad der ikke kunne lade sig gøre.
      if (issues.length < 1) {
        return
      }
      if (info.added.length > 0) {
        eventbus.toast = {
          text: 'Tilføjede ' + info.added.length + ' kompetencer. Ikke tilføjet: ' + issues.join('; '),
          success: false
        }
        return
      }
      eventbus.toast = { text: 'Intet tilføjet. ' + issues.join('; '), success: false }
    }
  }
}
</script>



// WEBPACK FOOTER //
// KompetenceIndberetningDSelect.vue?a51fe288